import React, {useEffect, useState, memo} from "../../../../__snowpack__/pkg/react.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
import {Modal, Pagination, Tooltip} from "../../../../__snowpack__/pkg/antd.js";
import useTable from "../../../hooks/mutations/useTable/index.js";
import request from "../../../utils/request/index.js";
import SearchForm from "../../../components/SearchForm/index.js";
import GnForm from "../../../components/GnForm/index.js";
import GnTable from "../../../components/GnTable/index.js";
import moment from "../../../../__snowpack__/pkg/moment-timezone.js";
import styled from "../../../../__snowpack__/pkg/styled-components.js";
export const PushLogModal = memo((props) => {
  const {visible, record, operationTypeList, onHandleCancelCallback} = props;
  const {formatMessage} = useIntl();
  const [form] = GnForm.useForm();
  const [moduleTypeList, setModuleTypeList] = useState([]);
  const {search, tableProps, pagination} = useTable((params) => {
    params.createTimeFrom = params?.createDatetime && params?.createDatetime[0];
    params.createTimeTo = params?.createDatetime && params?.createDatetime[1];
    delete params?.createDatetime;
    params.billNo = record?.no;
    params.operationTypeList = operationTypeList;
    return request.post("/saas/billOperationLog/searchPage", {...params});
  }, {
    form,
    refreshDeps: [visible],
    ready: visible
  });
  const formatOperationType = (operationType) => {
    return [
      "SELL_OUTBOUND_TRY_TO_PUSH_THIRD_WAREHOUSE",
      "SELL_OUTBOUND_THIRD_WAREHOUSE_CALLBACK_SUCCESS_PUSH",
      "SELL_OUTBOUND_THIRD_WAREHOUSE_CALLBACK_FAIL_PUSH"
    ].includes(operationType) ? formatMessage({id: "outboundOrderPushed"}) : formatMessage({id: "inboundOrderPushed"});
  };
  const columns = [
    {
      title: formatMessage({id: "operationTime"}),
      key: "createDatetime",
      dataIndex: "createDatetime",
      render: (text, record2) => {
        return text && moment(text).format("DD-MM-YYYY HH:mm") || "-";
      }
    },
    {
      title: formatMessage({id: "operationModule"}),
      key: "operationType",
      dataIndex: "operationType",
      render: (text, record2) => {
        return formatOperationType(text) ?? "-";
      }
    },
    {
      title: formatMessage({id: "operationContent"}),
      key: "operationContent",
      dataIndex: "operationContent",
      width: 500,
      render: (text, record2) => {
        return /* @__PURE__ */ React.createElement("div", null, record2.operationContent?.map((item) => /* @__PURE__ */ React.createElement(ContentWrapper, null, /* @__PURE__ */ React.createElement(Tooltip, {
          title: item,
          overlayInnerStyle: item.length > 100 ? {width: 650} : {}
        }, item))));
      }
    },
    {
      title: formatMessage({id: "operator"}),
      key: "operatorName",
      dataIndex: "operatorName",
      render: (text, record2) => {
        return text ?? "-";
      }
    }
  ];
  const fetchModuleTypeList = async () => {
    const data = await request.get("/saas/stock/changeRecord/moduleType/list");
    if (data) {
      data?.map((item) => {
        item.label = item.moduleTypeName;
        item.value = item.moduleType;
        return item;
      });
      setModuleTypeList(data);
    }
  };
  const handleInit = async () => {
    fetchModuleTypeList();
  };
  useEffect(() => {
  }, []);
  return /* @__PURE__ */ React.createElement(Modal, {
    visible,
    afterClose: () => {
      form.resetFields();
    },
    title: formatMessage({id: "pushLog"}),
    width: 1100,
    footer: null,
    onCancel: () => {
      onHandleCancelCallback && onHandleCancelCallback();
    }
  }, /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(SearchForm, {
    search,
    form
  }, /* @__PURE__ */ React.createElement(SearchForm.Item, {
    name: "createDatetime",
    prefabKey: "DateRangePicker",
    componentProps: {
      format: "DD-MM-YYYY"
    }
  }), /* @__PURE__ */ React.createElement(SearchForm.Item, {
    name: "operatorName",
    prefabKey: "Input",
    componentProps: {
      placeholder: formatMessage({id: "operator"})
    }
  })), /* @__PURE__ */ React.createElement(GnTable, {
    scroll: {x: "max-content", y: 450},
    rowKey: "id",
    ...tableProps,
    columns,
    pagination: false,
    loading: tableProps.loading
  }), /* @__PURE__ */ React.createElement(FlexWrapper, {
    style: {marginTop: "26px"}
  }, /* @__PURE__ */ React.createElement(Pagination, {
    ...pagination
  }))));
});
export default PushLogModal;
const Wrapper = styled.div`
  .ant-table-cell {
    vertical-align: text-top;
  }
`;
const FlexWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
`;
const ContentWrapper = styled.span`
  letter-spacing: 0;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-size: 12px;
  width: 100%;
`;
